import { Sound } from '@/classes';
import { keyCodes } from '@/constants/keyCode';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { CSSProperties, DetailedHTMLProps, MouseEvent, useCallback, useEffect } from 'react';

export const FocusableButton = ({
  focusKey,
  onFocused,
  initFocus,
  ...props
}: DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  style?: CSSProperties;
  focusKey?: string;
  onFocused?: ({ x, y, left, top }: { x: number; y: number; left: number; top: number }) => void;
  initFocus?: boolean;
}) => {
  // ! onFocus 를 undefined 로 넘기면 useExtendFocusable 내부의 포커스 추적 핸들러까지 덮어쓴다.
  const { ref, focused, focusSelf } = useExtendFocusable({ focusKey, ...(onFocused ? { onFocus: onFocused } : {}) });
  const handleClick = useCallback(
    (e?: MouseEvent) => {
      if (e?.cancelable) {
        if (e?.preventDefault) e.preventDefault();
        if (e?.stopPropagation) e.stopPropagation();
      }

      Sound.press();
      if (props.onClick) {
        focusSelf();
        (props.onClick as any)();
      }
    },
    [focusSelf, props.onClick],
  );

  useFocusElement({ ref, focused, onClick: handleClick, keyCode: keyCodes.ENTER });

  useEffect(() => {
    if (initFocus) {
      focusSelf();
    }
  }, [focusSelf, initFocus]);

  return (
    <button ref={ref} {...props} onClick={handleClick} onContextMenu={handleClick}>
      {props.children}
    </button>
  );
};
